import { useEffect, useState, type ReactNode } from 'react';

import { fetchBookingConfig } from '../../api/bookingsV2';

import { GiftPassesEnabledContext } from './gift-passes-enabled-context';

/**
 * Loads the gift-pass flag once for everything beneath it. A failed load reads
 * as off; the server still refuses whichever refund option is off.
 */
export function GiftPassesEnabledProvider({ children }: { children: ReactNode }) {
  const [enabled, setEnabled] = useState<boolean | null>(null);
  useEffect(() => {
    let active = true;
    fetchBookingConfig()
      .then((cfg) => {
        if (active) setEnabled(cfg.giftPassesEnabled === true);
      })
      .catch(() => {
        if (active) setEnabled(false);
      });
    return () => {
      active = false;
    };
  }, []);
  return (
    <GiftPassesEnabledContext.Provider value={enabled}>
      {children}
    </GiftPassesEnabledContext.Provider>
  );
}
